import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { DialogData } from '../../mapa-popup/mapa-popup.component';
import { PuntosService } from 'src/app/shared/services/puntos-service/puntos.service';
import { PuntoGrupo } from 'src/app/models/punto-grupo.model';
import { PuntoTipo } from 'src/app/models/punto-tipo.model';
import { PuntoPais } from 'src/app/models/punto-pais.model';
import { PuntoIcono } from 'src/app/models/punto-icono.model';
import { FormBuilder, FormControl, Validators, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-agregar-punto',
  templateUrl: './agregar-punto.component.html',
  styleUrls: ['./agregar-punto.component.scss']
})
export class AgregarPuntoComponent implements OnInit {

  @ViewChild('listagrupo', { static: true }) listagrupo;
  @ViewChild('listatipopuntos', { static: true }) listatipopuntos;
  @ViewChild('listapais', { static: true }) listapais;
  @ViewChild('listaiconos', { static: true }) listaiconos;

  public loading: boolean = false;
  public alertFail: boolean = false;
  public alertSuccess: boolean = false;
  public alertMsg: string = '';
  form: FormGroup;
  public params = {
    descripcion: null,
    grupo: '',
    latitud: null,
    longitud: null,
    pais: '1',
    radio: 1,
    tipopunto: '2',
    icono: {
      idIcono: null,
      descripcion: null,
      imgPath: null,
    },
  };
  public grupos = [];
  public gruposFiltered = [];
  public tipopuntos = [];
  public tipopuntosFiltered = [];
  public pais = [];
  public paisFiltered = [];
  public iconos = [];
  public iconosFiltered = [];

  constructor(
    public dialogRef: MatDialogRef<AgregarPuntoComponent>,
    public formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) 
    public data: DialogData,
    public puntosService: PuntosService,
  ) { }

  ngOnInit() {    
    this.params.latitud = this.data.latitud;
    this.params.longitud = this.data.longitud;
    this.callGrupos();
    this.callTipoPuntos();
    this.callPais();
    this.callIconos();
    this.form = this.formBuilder.group({
      latitud: new FormControl('', Validators.required),
      longitud: new FormControl('', Validators.required),
      descripcion: new FormControl('', Validators.required),
      grupos: new FormControl('', Validators.required),
      pais: new FormControl('', Validators.required),
      punto: new FormControl('', Validators.required),
      radio: new FormControl('', Validators.required),
      icono: new FormControl('', Validators.required),
    });
    this.params.radio = 20;
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  callGrupos(){
    this.puntosService.getGrupos().subscribe(res => {     
      console.log(res) 
      let data = [];
      /* data.push(new PuntoGrupo({
        idGrupo : 0,
        descripcion : 'Puntos Generales',
        observacion : '',
      })); */
      Object.values(res).forEach(el => {
        //console.log(el)
        data.push(new PuntoGrupo(el));
      });
      this.grupos = data;
      this.gruposFiltered = data;
    });
  }

  callTipoPuntos(){
    this.puntosService.getTipoPuntos().subscribe(res => {      
      let data = [];
      Object.values(res).forEach(el => {
        data.push(new PuntoTipo(el));
      });
      this.tipopuntos = data;
      this.tipopuntosFiltered = data;
    });
  }

  callPais(){
    this.puntosService.getPais().subscribe(res => {      
      let data = [];
      Object.values(res).forEach(el => {
        data.push(new PuntoPais(el));
      });
      this.pais = data;
      this.paisFiltered = data;
    });
  }

  callIconos(){
    this.puntosService.getIconos().subscribe(res => {      
      let data = [];      
      Object.values(res).forEach(el => {
        data.push(new PuntoIcono(el));
      });
      this.iconos = data;
      this.iconosFiltered = data;
    });
  }

  filterGrupo(query) {
    let res = this.grupos.filter(s => (s.descripcion.toLocaleLowerCase().includes(query.toLocaleLowerCase())));
    this.gruposFiltered = (query == '') ? this.grupos : res;
  }

  filterTipoPuntos(query) {
    let res = this.tipopuntos.filter(s => (s.descripcion.toLocaleLowerCase().includes(query.toLocaleLowerCase())));
    this.tipopuntosFiltered = (query == '') ? this.tipopuntos : res;
  }

  filterPais(query) {
    let res = this.pais.filter(s => (s.nom_pais.toLocaleLowerCase().includes(query.toLocaleLowerCase())));
    this.paisFiltered = (query == '') ? this.pais : res;
  }

  filterIconos(query) {
    let res = this.iconos.filter(s => (s.descripcion.toLocaleLowerCase().includes(query.toLocaleLowerCase())));
    this.iconosFiltered = (query == '') ? this.iconos : res;
  }

  sendPunto(){
    this.loading = true;
    this.alertFail = false;
    this.alertSuccess = false;
    var error = false;
    if(!this.params.descripcion){ error = true; }
    //if(!this.params.grupo){ error = true; }
    if(!this.params.icono.idIcono){ error = true; }
    if(!this.params.icono.descripcion){ error = true; }
    if(!this.params.icono.imgPath){ error = true; }    
    if (error) {
      this.alertMsg = 'FAVOR COMPLETAR TODOS LOS CAMPOS';
      this.alertFail = true;
      this.loading = false;
      setTimeout(() => {
        this.alertFail = false;
      }, 2000); 
      return;
    }

    this.puntosService.addPunto(this.params).subscribe(res => {
      this.alertMsg = 'PUNTO CREADO';
      this.alertSuccess = true;
      setTimeout(() => {
        this.loading = false;
        this.dialogRef.close();
      }, 2000);      
    }, function(error){
        console.log(error);
        this.alertMsg = 'HA OCURRIDO UN PROBLEMA, FAVOR INTENTARLO MÁS TARDE';
        this.alertFail = true;
        this.loading = false;        
        return;
    });
    
  }

}
